module.exports = __webpack_public_path__ + "assets/asap-3ab600.svg";